
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class BranchOutDialog extends _Ext.TransDialog<BranchOutRow, any> {

        protected getFormKey() { return BranchOutForm.formKey; }
        protected getIdProperty() { return BranchOutRow.idProperty; }
        protected getLocalTextPrefix() { return BranchOutRow.localTextPrefix; }
        protected getNameProperty() { return BranchOutRow.nameProperty; }
        protected getService() { return BranchOutService.baseUrl; }
        protected getDeletePermission() { return BranchOutRow.deletePermission; }
        protected getInsertPermission() { return BranchOutRow.insertPermission; }
        protected getUpdatePermission() { return BranchOutRow.updatePermission; }
        protected useViewMode() { return true; }

        public form = new BranchOutForm(this.idPrefix);
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
         
        TaxArray: any[];  
        //ProdctImage of Items
        static image: string; 
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 290;
            q.initItemEditor(this, this.form.ItemDetails, Config);
            //Make grid full width
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.hideEditorLabel(this.form.ItemDetails); 
            q.hideEditorLabel(this.form.TaxDetails);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.TaxAmount);
            //q.setGridEditorHeight(this.form.ItemDetails, 300);
            q.setGridEditorHeight(this.form.TaxDetails, 150);
            q.hideEditorToolbar(this.form.TaxDetails);
            //To Hide Image Toolbar & Label
            q.hideImageToolbar(this.form.ProductItemImage);
            q.hideEditorLabel(this.form.ProductItemImage);

            //To Show Image on Right Top & Hide Categories
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.BillNo);
            q.SetCategoryTwoColumn(this.form.ProductItemImage);
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.SetSix12Column(this.form.TaxDetails);
            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.NetAmount);
            q.SetCategoryFullWidth(this.form.Remark);
            q.HideCategoryLable(this.element);
            //this.form.CompanyName.getGridField().find('.caption').attr('Style', 'display:none');




            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });
            
            this.form.BranchId.changeSelect2(e => {
                Q.reloadLookup('AllDepartments');
                var BranchDetails = OMS.CompanyRow.getLookup().itemById[this.form.BranchId.value];
                this.form.ItemDetails.PartyId = Q.toId(this.form.BranchId.value);
                this.form.ItemDetails.RateListId = BranchDetails.PPriceListId || 0;
                this.form.ItemDetails.StoneMarkup = BranchDetails.PMarkup || 0;
                this.form.ItemDetails.LaborListId = BranchDetails.PLabourListId || 0;
                this.form.ItemDetails.LaborMarkup = BranchDetails.PLMarkup || 0;

                this.form.DepartmentId.cascadeField = "CompanyId";
                this.form.DepartmentId.cascadeValue = BranchDetails.CompanyId;
            });


            //Load Image after Row in Details is Clicked
            var _this = this;
            this.form.ItemDetails.slickGrid.onClick.subscribe(function (e, args) {

                var x: Serenity.UploadedFile = {
                    Filename: BranchOutDialog.image,
                    OriginalName: ""
                }
                _this.form.ProductItemImage.value = x;//POSSalesDialog.image;

                //Set Image Width & Height

                q.setImageEditorHeight(_this.form.ProductItemImage, 160);
            });
            // **** Calculate Net,Gross Amount, Discount and Tax from Item Details and show on form ****
            var ItemTotal = 0;
            var Items: any;
            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                Items = this.form.ItemDetails.getItems();

                var TotalItems = this.form.ItemDetails.getTotalRows();
                if (ItemTotal > 0) {
                    ItemTotal = 0;
                }

                this.CalculateAmountandTax(Items, TotalItems);
                var items = this.form.ItemDetails.getItems();
                let pieces = [];
                let weight = [];
                let itemids = [];
                items.forEach(function (value) {
                    itemids.push(value.TransItemId);
                    pieces.push(value.Pieces);
                    weight.push(value.Weight);
                });
                this.form.ItemDetails.itemids = itemids;
                this.form.ItemDetails.pieces = pieces;
                this.form.ItemDetails.weight = weight;

            })

            this.form.GrossAmount.addValidationRule(this.uniqueName, e => {
                //Validate that the knock off value is not less than or greater than total Amount
                if (this.form.ItemDetails.getItems().length == 0) {
                    Q.alert("There are no Items added in transaction. Can not save!!")
                    return "";
                }
            });

            this.validateForm();
            
        } 
        public CalculateAmountandTax(Items: any, TotalItems: number) {

            var HSN = [];
            var Amount = [];
            var TaxDetail = [];
            var ItemTotal = 0;
            var ntamt = 0; var gramt = 0; var disc = 0; var tax = 0; var pcs = 0; var wt = 0; var nwt = 0; var tds = 0;

            for (var x of Items) {
                ntamt += x.NetAmount || 0;
                gramt += x.GrossAmount || 0;
                disc += x.Discount || 0;
                pcs += x.Pieces || 0;
                wt += x.Weight || 0;
                nwt += x.NetWeight || 0;

                var temp = false;
                for (let i = 0; i < HSN.length; i++) {
                    if (HSN[i] == x.TaxCode) {
                        Amount[i] += x.GrossAmount || 0;
                        temp = true;
                    }
                }

                if (!temp) {
                    HSN.push(x.TaxCode);
                    Amount.push(x.GrossAmount);
                }
                ItemTotal++;
            };

            this.form.NetAmount.value = gramt;
            this.form.Discount.value = disc;

            var TaxAmount = 0;

            var TaxApplicable = OMS.VoucherMasterRow.getLookup().items.filter(x => x.VoucherTypeId == this.form.VoucherTypeId.value)[0].IsTaxApplicable;

            if (ItemTotal == TotalItems && TaxApplicable) {

                var TaxItems = this.form.TaxDetails.getItems().length;
                var it = this.form.TaxDetails.getItems();
                if (TaxItems > 0) {
                    this.form.TaxDetails.DeleteTax();
                }

              //  var partystate = OMS.VendorRow.getLookup().itemById[this.form.PartyId.value].State;
                var Cmpstate = OMS.CompanyRow.getLookup().itemById[Q.Authorization.userDefinition.CompanyId].State;

                //TODO: Get Company Country to Call appropriate TAX Helper

                //if (partystate == Cmpstate) {

                //    TaxDetail = TaxHelper.NewTaxCalculation(HSN, Amount, this.form.TransDate.value, false,0);
                //    //var cols = this.form.TaxDetails.slickGrid.getColumns();
                //    //var cols = cols.filter(x => x.field != "TaxId" && x.field != "TaxRate" && x.field != "TaxAmount");
                //    //this.form.TaxDetails.slickGrid.setColumns(cols);

                //}
                //else {

                    TaxDetail = TaxHelper.NewTaxCalculation(HSN, Amount, this.form.TransDate.value, true, 0);
                    //var cols = this.form.TaxDetails.slickGrid.getColumns();
                    //var cols = cols.filter(x => x.field != "Tax1Id" && x.field != "Tax1Rate" && x.field != "Tax1Amount" && x.field != "Tax2Id" && x.field != "Tax2Rate" && x.field != "Tax2Amount");
                    //this.form.TaxDetails.slickGrid.setColumns(cols);

               // }
                //Get Taxes for Voucher
                TaxDetail = TaxHelper.VoucherTaxCalculation(this.form.VoucherTypeId.value, gramt, this.form.TransDate.value, TaxDetail,false);




                var temp2 = this.form.TaxDetails.getData(TaxDetail);
                this.form.TaxDetails.view.setItems(temp2, true);

                TaxDetail.forEach(function (value) {
                    if (value.TaxType != "TDS")
                        TaxAmount += value.TaxAmount;
                    else
                        tds += value.TaxAmount;

                });

                this.form.TaxAmount.value = TaxAmount;
                this.form.GrossAmount.value = gramt + TaxAmount;
                this.form.Pieces.value = pcs;
                this.form.Weight.value = wt;
                this.form.NetWeight.value = nwt;
            }
            else {
                this.form.GrossAmount.value = gramt;
                this.form.Pieces.value = pcs;
                this.form.Weight.value = wt;
                this.form.NetWeight.value = nwt;
            }
        }


        protected onDialogOpen() {
            super.onDialogOpen();
             
            if (this.form.BranchId.value == "") {
                var company = OMS.CompanyRow.getLookup().itemById[Q.Authorization.userDefinition.CompanyId];
                if (company.TypeOfCompany.toString() == "Parent") {
                    this.form.BranchId.cascadeField = "ParentCompany"
                    this.form.BranchId.cascadeValue = Q.Authorization.userDefinition.CompanyId;
                } else if (company.TypeOfCompany.toString() == "Branch") {
                    this.form.BranchId.cascadeField = "ParentCompany"
                    this.form.BranchId.cascadeValue = company.ParentCompany;
                }
                
            }
            else if (this.form.BranchId.value != "") {
                var branchId = this.form.BranchId.value;
                var company = OMS.CompanyRow.getLookup().itemById[Q.Authorization.userDefinition.CompanyId];
                if (company.TypeOfCompany.toString() == "Parent") {
                    this.form.BranchId.cascadeField = "ParentCompany"
                    this.form.BranchId.cascadeValue = Q.Authorization.userDefinition.CompanyId;
                } else if (company.TypeOfCompany.toString() == "Branch") {
                    this.form.BranchId.cascadeField = "ParentCompany"
                    this.form.BranchId.cascadeValue = company.ParentCompany;
                }
                this.form.BranchId.value = branchId;
            }
            //Editable TransDate
            this.form.BranchId.items = this.form.BranchId.items.filter(x => x.id != Q.Authorization.userDefinition.CompanyId.toString());

         
            this.form.GrossAmount.value = 0;
            this.form.ItemDetails.isUpdate = 0;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            let companyDetails = OMS.CompanyRow.getLookup().itemById[this.form.CompanyId.value];
            this.RateListId = companyDetails.SPriceListId == null ? 0 : companyDetails.SPriceListId;
            this.LaborListId = companyDetails.SLabourListId == null ? 0 : companyDetails.SLabourListId;
            this.StoneMarkup = companyDetails.SMarkup == null ? 0 : companyDetails.SMarkup;
            //this.StoneDiscount = companyDetails.== null ? 0 : companyDetails.StnAddDisc;
            this.LaborMarkup = companyDetails.SLMarkup == null ? 0 : companyDetails.SLMarkup;
            //this.LaborDiscount = companyDetails.LbrAddDisc == null ? 0 : companyDetails.LbrAddDisc;
            var x = this.entity.CurrencyId;
            var y = this.form.TransDate.value;
            var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.entity.CurrencyId.toString() && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
            this.ExchangeRate = ExchangeDetails.ExchRate;
        }



        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };


            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };

            //Export PDF Button
            btns.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                icon: 'fa fa-print text-blue',
                reportKey: 'Inventory.BranchOutVoucher',
                getParams: () => ({
                    TransID: this.get_entityId()
                })
            }));
            var postingpermission = Q.Authorization.hasPermission('Inventory:BranchOut:Posting');
            //Export PDF Button
            btns.push({
                title: 'Post',
                icon: 'las la-check-double',
                cssClass: 'approve-doc-button',
                onClick: () => {
                    var entity = this.entity;
                    entity.AutoPosting = true; delete entity.TransDate;

                    BranchOutService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
                        if (response.Error == null) {
                            this.dialogClose();
                            Serenity.SubDialogHelper.triggerDataChange(this);
                        }
                    }, { async: false })
                },
                visible: postingpermission

            });
             

            return btns;
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            let valid = true;
            BranchInService.CheckIfAuthorized({
                RefTransId: parseInt(this.form.TransId.value)
            }, response => {
                if (response.Entity != null) {
                    q.Alert('', "This Voucher has been Authorized. Can Not Edit!", 3000, false);
                    valid = false;
                    return;
                }
            }, { async: false });
            if (valid) {
                Stock.StockItemService.CheckTransaction(
                    { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                    response => {
                        if (response.Entities != null && response.Entities.length > 0)
                            refid = response.Entities[0];
                    }, { async: false }
                )
                if (refid != null) {
                    if (refid.PartyId != null || refid.PartyId > 0) {
                        Q.alert("This Voucher has been used in transactions Can Not Delete!");
                        return;
                    }
                } else {
                    Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
                    this.form.ItemDetails.canUpdate = 1;
                    if (!self.isEditMode())
                        return;
                    self.editClicked = true;
                    self.updateInterface();
                    self.updateTitle();
                }
            }
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                BranchOutService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        }

        validateBeforeSave() {
            var Isvalid = super.validateBeforeSave();
            if (this.form.ItemDetails.getItems().length == 0) {
                Q.alert("No Items added, At least add one entry. Can not Save! ")
                Isvalid = false;
            }
            for (var i = 0; i < this.form.ItemDetails.getItems().length; i++) {
                let items = this.form.ItemDetails.getItems();
                items[i].BOMDetails.forEach(function (x) {
                    if (x.BomRate == null || x.BomRate <= 0 || x.BomAmount == null || x.BomAmount <= 0) {
                        var msg = q.text('Message.Component.RateNotDefined', 'Rate not Defined for Component "' +items[i].ProductCode+'", Cannot Save!');
                        Q.alert(msg)
                        Isvalid = false;
                    }
                })

                if (items[i].LaborDetails.length > 0) {
                    items[i].LaborDetails.forEach(function (x) {
                        if (x.LabourRate == null|| x.LabourRate <= 0 || x.LabourAmount == null || x.LabourAmount <= 0) {
                            Q.alert("Rate not Defined for labor, Can not Save!")
                            Isvalid = false;
                        }
                    })
                }
            }

            return Isvalid;

        }
         
        validateEntity(row: BranchOutRow, id: number) {

            if (row.ItemDetails.length == 0) {
                Q.alert("No Items added, Atleast add one entry. Can not Save! ")
                return false;
            } 
                return true;
        }
    }
}